import { render } from "./AboutQC.vue?vue&type=template&id=3fa45fda"
import script from "./AboutQC.vue?vue&type=script&lang=js"
export * from "./AboutQC.vue?vue&type=script&lang=js"

import "./AboutQC.vue?vue&type=style&index=0&id=3fa45fda&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__